import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PageContainer from "@src/components/containers/PageContainer";
import PageContent from "@src/components/containers/PageContent/PageContent";
import PageHeader from "@src/components/common/PageHeader";
import PageFooter from "@src/components/common/PageFooter";
import ClinicDesktopPageBanner from "@src/components/pages/clinic-portal/ClinicDesktopPage/ClinicDesktopPageBanner";
import isOnPage, {
  A_CART_SUMMARY_PAGE,
  DASHBOARD_PAGE,
} from "@src/utils/isOnPage";
import styles from "./ClinicPortalContainer.module.scss";
import CartSummary from "@src/components/widgets/CartSummary";
import { useCartStore } from "@src/state/cartState";
import { useCurrentUserStore } from "@src/state/currentUserState";
import { useFavoriteProductsStore } from "@src/state/favoriteProductsState";
import useDjangoMessages from "@src/hooks/useDjangoMessages";
import { getHasPermission } from "@src/utils/permission";
import Permissions from "@src/constants/Permissions";
import PermissionLevels from "@src/constants/PermissionLevels";

export default function ClinicPortalContainer(): React.JSX.Element {
  const { cartCount } = useCartStore();
  const location = useLocation();
  const { currentUser, fetchDistributorApiHealthStatuses } =
    useCurrentUserStore();
  const { fetchFavoriteIds } = useFavoriteProductsStore();
  useDjangoMessages();

  useEffect(() => {
    if (window.pendo && !!window.pendo.pageLoad) {
      window.pendo.pageLoad();
      console.log("[Pendo] pageLoad triggered for path:", location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      currentUser &&
      getHasPermission(
        currentUser,
        Permissions.Distributors,
        PermissionLevels.View,
      )
    ) {
      const intervalId = setInterval(() => {
        fetchDistributorApiHealthStatuses();
      }, 5000); // Every 5 seconds

      fetchDistributorApiHealthStatuses(); // Initial fetch

      return () => clearInterval(intervalId);
    }
  }, [currentUser]);

  useEffect(() => {
    if (
      currentUser &&
      getHasPermission(currentUser, Permissions.Products, PermissionLevels.View)
    ) {
      fetchFavoriteIds();
    }
  }, [currentUser]);

  return (
    <PageContainer>
      <div className="flex-row">
        <div className="flex-1">
          <PageHeader />

          {isOnPage(DASHBOARD_PAGE, location.pathname) && (
            <ClinicDesktopPageBanner />
          )}
          <PageContent>
            <Outlet />
          </PageContent>

          <PageFooter />
        </div>

        {isOnPage(A_CART_SUMMARY_PAGE, location.pathname) &&
          !!cartCount &&
          cartCount > 0 && (
            <div className={styles.cartSummarySlideIn}>
              <CartSummary />
            </div>
          )}
      </div>
    </PageContainer>
  );
}
